import {
  LEFT_SIDE_WIDTH_RANGE,
  RIGHT_SIDE_WIDTH_RANGE,
} from "../../constants/display";

import { HandleComponent } from "./HandleComponent";

export const leftRange = Object.entries(LEFT_SIDE_WIDTH_RANGE)
  .reduce((acc, [k, v]) => ({...acc, [`${k}Width`]: `${v}%`}), {});
export const rightRange = Object.entries(RIGHT_SIDE_WIDTH_RANGE)
  .reduce((acc, [k, v]) => ({...acc, [`${k === "min" ? "max" : "min"}Width`]: `${100 - v}%`}), {});

export default {
  style: {
    zIndex: 1,
  },
  enableResizing: { right: true },
  resizeHandleComponent: {
    right: HandleComponent,
  },
  disableDragging: true,
};
